export default class ServiceMessages {
  constructor(contents, code, response) {
    this.code = code;
    this.response = response;
    this.type = 'danger';
    this.contents = contents;
  }
}
